import { Color } from "@repo/app-types/constants/colors";
import { QUESTION_SUMMARY_MAX_INTERVIEW_COUNT } from "@repo/app-types/constants/shared";
import type { Keyword } from "@repo/app-types/entities/keyword";
import type { ProjectWithInterviewCount } from "@repo/app-types/entities/project";
import type React from "react";
import { useAppSelector } from "../../hooks/hook.js";
import { InsightBar } from "./insightBar.js";
import { selectKeywordTrackerIdToMatches } from "./insightsSlice.js";

interface QuestionThemeAnalysisCellProps {
  project: ProjectWithInterviewCount;
  keyword_tracker_id: string;
  keyword: Keyword;
}

// Renders the "% of interviews" cell for a keyword.
export const QuestionThemeAnalysisCell: React.FC<
  QuestionThemeAnalysisCellProps
> = ({ project, keyword, keyword_tracker_id }) => {
  const keywordTrackerIdToMatches = useAppSelector(
    selectKeywordTrackerIdToMatches,
  );

  const keywordTrackerMatches = keywordTrackerIdToMatches[keyword_tracker_id];

  const totalInterviewCount = project.interview_count;

  // Question summaries are capped at 25 most recent responses
  const interviewDenominatorCount =
    totalInterviewCount > QUESTION_SUMMARY_MAX_INTERVIEW_COUNT
      ? QUESTION_SUMMARY_MAX_INTERVIEW_COUNT
      : totalInterviewCount;

  const numMatchingInterviews =
    keywordTrackerMatches?.[keyword.phrase]?.interview_ids.length ?? 0;

  const interviewPercentage =
    interviewDenominatorCount > 0
      ? Math.round((numMatchingInterviews / interviewDenominatorCount) * 100)
      : 0;

  return (
    <div className="flex flex-col space-y-2">
      <InsightBar
        color={Color.Blue}
        percentageWidth={interviewPercentage}
        label={`${interviewPercentage}% of interviews`}
      />
    </div>
  );
};
